/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { Outlet, Route, Routes } from 'react-router-dom'
import { KTSVG, toAbsoluteUrl } from '../../../_metronic/helpers'
import { Footer } from '../../../_metronic/layout/components/Footer'
import { LandingHeaderWrapper } from '../../../_metronic/layout/components/header/LandingHeaderWrapper'
import BusinessCentricContent from './components/BusinessCentricContent'
import Hero from './components/Hero'
import { Login } from './components/Login'
import Testimonial from './components/Testimonial'
import TopDeveloperList from './components/TopDeveloperList'
import UniqueInsights from './components/UniqueInsights'

const LandingLayout = () => {
  const [loginModal, setloginModal] = useState(false)

  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])
  const handleloginModal = () => {
    setloginModal(!loginModal)
  }
  return (
    <div className='page d-flex flex-column flex-column-fluid'>
      <LandingHeaderWrapper />
      <div className='d-flex flex-column container   my-10  '>
        <Hero handleloginModal={handleloginModal} />
      </div>
      <UniqueInsights handleloginModal={handleloginModal} />
      <div className='d-flex flex-column  bg-secondary py-20'>
        <div className='container'>
          <div className='my-9 row '>
            <div className='col-md-6'>
              <img src={toAbsoluteUrl('/media/svg/illustrations/easy/rowing.svg')} alt='rowing' />
            </div>
            <div className='col-md-6'>
              <div className='display-6 fw-bolder mb-10'>Remote is challenging</div>
              <div className='my-10 d-flex align-items-center'>
                <div className='bg-white border p-4 rounded mr-4'>
                  <KTSVG
                    path='/media/icons/duotune/general/gen004.svg'
                    className='svg-icon-1 svg-icon-primary'
                  />
                </div>
                <div className='mx-4' />
                <div className='fs-3 fw-400 me-3'>
                  Building an extensive global pipeline to find great people
                </div>{' '}
              </div>
              <div className='my-10 d-flex align-items-center'>
                <div className='bg-white border p-4 rounded mr-4'>
                  <KTSVG
                    path='/media/icons/duotune/general/gen012.svg'
                    className='svg-icon-1 svg-icon-primary'
                  />
                </div>
                <div className='mx-4' />
                <div className='fs-3 fw-400 me-3'>
                  Vetting remote candidates without taking up all of the engineering time
                </div>{' '}
              </div>
              <div className='my-10 d-flex align-items-center'>
                <div className='bg-white border p-4 rounded mr-4'>
                  <KTSVG
                    path='/media/icons/duotune/general/gen048.svg'
                    className='svg-icon-1 svg-icon-primary'
                  />
                </div>
                <div className='mx-4' />
                <div className='fs-3 fw-400 me-3'>
                  Making remote development easy, compliant, and secure
                </div>{' '}
              </div>
              <button
                onClick={handleloginModal}
                className='btn btn-primary fw-bold px-6 py-3 btn-hover-scale align-self-end '
              >
                Apply now
                <KTSVG
                  path='/media/icons/duotune/arrows/arr024.svg'
                  className='svg-icon-2 svg-icon-success  ms-2'
                />{' '}
              </button>
            </div>
          </div>
        </div>
      </div>
      <BusinessCentricContent />
      {/* begin::Content */}
      <Testimonial />
      <TopDeveloperList />
      <Footer />
      <Modal
        show={loginModal}
        onHide={handleloginModal}
        contentClassName='bg-transparent border-0 shadow-none'
      >
        <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
          {/* begin::Wrapper */}
          <div className='w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto'>
            <a
              href='#'
              className='mb-6 d-flex text-center align-self-center justify-content-center'
            >
              <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo.png')} className='h-45px  ' />
            </a>
            <Outlet></Outlet>
          </div>
          {/* end::Wrapper */}
        </div>
      </Modal>
    </div>
  )
}

const LandingPage = () => (
  <Routes>
    <Route element={<LandingLayout />}>
      <Route path='login' element={<Login />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export { LandingPage }

